
import { defineComponent } from "vue";
import Button from "../Buttons/Button.vue";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiShopping, mdiShoppingOutline } from "@mdi/js";
import { Inertia } from "@inertiajs/inertia";
import { useStore } from "@/stores/order";

export default defineComponent({
  setup() {
    const bagIds = {
      small: 10247,
      medium: 10248,
      large: 10249,
    };

    const orderStore = useStore();

    const addBag = (size: "small" | "medium" | "large") => {
      const bagId = bagIds[size];

      Inertia.post(
        route("orders.orderlines.store", { order: orderStore.order_id }),
        {
          product_id: bagId,
          amount: 1,
        },
        {
          onSuccess: () => {
            const detailsElement = document.getElementById("orderDetails");
            console.log({ detailsElement });
            detailsElement?.scrollTo(0, detailsElement?.scrollHeight);
          },
        }
      );
    };

    return {
      addBag,
      bagIcon: mdiShoppingOutline,
    };
  },
  components: { Button, SvgIcon },
});
